export const UPDATE_UI_MODE = 'UPDATE_UI_MODE'
